export default [
  {
    path: '/main/reportdevicelogs',
    meta: {
      tag: 'report_devicelogs',
      name: 'Device Logs',
      breadcrumb: 'Device Logs'
    },
    component: () => import(/* webpackChunkName: "report-devicelogs" */ '@/views/main/reports/devicelogs/Index.vue'),
    children: [
      {
        path: '',
        name: 'listdevicelogs',
        meta: {
          tag: 'report_devicelogs',
          name: 'Device Logs',
          menu: 'reports',
        },
        component: () => import(/* webpackChunkName: "report-devicelogs" */ '@/views/main/reports/devicelogs/List.vue'),
      }
    ]
  }
]
